import { ICONS } from './icons';
import {
	IconAddFileCreateNoteScriptDocumentDuotone,
	IconAddFolderDuotone,
	IconAlertDuotoneCircle,
	IconAngleDuotone,
	IconArrowDownOutline,
	IconArrowDownSolid,
	IconArrowLeft2Outline,
	IconArrowLeft2Solid,
	IconArrowLeftOutline,
	IconArrowRight2Outline,
	IconArrowRight2Solid,
	IconArrowRightOutline,
	IconArrowShareDuotone,
	IconArrowUpDuotone,
	IconArrowUpOutline,
	IconArrowUpSolid,
	IconAttachOutline,
	IconBackgroundRemoveDuotone,
	IconBackgroundRestoreDuotone,
	IconBackgroundRestoreSolid,
	IconBelowTheFoldDuotone,
	IconBelowTheFoldSolid,
	IconBoldOutline,
	IconBookendsDuotone,
	IconCalendarAddDuotone,
	IconCalendarDuotone,
	IconCalendarStarMenuMeetingsFavoriteDuotone,
	IconCameraOffDuotone,
	IconCameraOnDuotone,
	IconCaseProfileDuotone,
	IconChatDefaultDuotone,
	IconChatDuotone,
	IconCheckOutline,
	IconCheckboxCheckedDuotone,
	IconCheckboxOutline,
	IconClockDefaultDuotone,
	IconClockDefaultOutline,
	IconCloseOutline,
	IconCollapseDuotone,
	IconCopy,
	IconCopyDuplicate,
	IconCopyDuplicateSolid,
	IconCountdownsDuotone,
	IconCountdownsOutline,
	IconDelete,
	IconDeviceDesktopMonitorDuotone,
	IconDeviceMobileDuotone,
	IconDownloadCloudDefault,
	IconDownloadOutline,
	IconDragSolid,
	IconEditDuotone,
	IconEmailDuotone,
	IconEmailOutline,
	IconEmojiDuotone,
	IconExpandDuotone,
	IconExpandSolid,
	IconExternalLinkOutline,
	IconEyedropperDuotone,
	IconFastForwardDuotone,
	IconFeedDuotone,
	IconFileDocumentPageScriptTextEmptyDuotone,
	IconFilterDuotone,
	IconFireDuotone,
	IconFolderDuotone,
	IconFontDuotone,
	IconHandRaiseSolid,
	IconHeadphonesDuotone,
	IconHideEye,
	IconImageMediaDuotone,
	IconImageMediaOutline,
	IconInfoCircle,
	IconInfoOutline,
	IconItalicOutline,
	IconLayersThreeDuotone,
	IconLayoutFlipHorizontalSolid,
	IconLayoutNumericListOutline,
	IconLinkDuotone,
	IconLinkOutline,
	IconListBoxOutline,
	IconLiveSolid,
	IconLock,
	IconLogInOutline,
	IconLogOutOutline,
	IconLowersDuotone,
	IconLowersSolid,
	IconMarkerDuotone,
	IconMenuHorizontal2ThreeMoreOutline,
	IconMenuVertical2Outline,
	IconMenuVerticalOutline,
	IconMicOffDuotone,
	IconMicOnDuotone,
	IconMoveToBottomDuotone,
	IconMoveToTopDuotone,
	IconMusicSoundAudioDuotone,
	IconMuteDuotone,
	IconNotesDuotone,
	IconNotliveSolid,
	IconPhotoDuotone,
	IconPinLocationDuotone,
	IconPlaySolid,
	IconPlusOutline,
	IconPreviousArrowSolid,
	IconQuestionOutline,
	IconRadioCheckedOutline,
	IconRecordSolid,
	IconRedoReplaceOutline,
	IconRefreshOutline,
	IconReloadOutline,
	IconRepeatOffSolid,
	IconRepeatOutline,
	IconRocketDuotone,
	IconRoundAdd,
	IconRoundCheck,
	IconRoundCheckOutline,
	IconRoundQuestionOutline,
	IconSaxTextUnderlineOutline,
	IconSearchOutline,
	IconSegmentsDuotone,
	IconSendDuotone,
	IconSendSolid,
	IconSettingsDuotone,
	IconShareScreenDuotone,
	IconSharescreenOffDuotone,
	IconShotFrameDuotone,
	IconShowEye,
	IconSidenavOnDuotone,
	IconSoundOffDuotone,
	IconSoundVolumeDownDuotone,
	IconSoundVolumeUp2Solid,
	IconSoundVolumeUpDuotone,
	IconSoundVolumeUpSolid,
	IconSparkleAiOutline,
	IconStopSolid,
	IconStylepacksDuotoneCopy,
	IconTeleprompterDuotone,
	IconTemplateDuotone,
	IconTimerOutline,
	IconTrimDuotone,
	IconUndoOutline,
	IconUploadOutline,
	IconUserAddDuotone,
	IconUserDuotone,
	IconUserOutline,
	IconUserShowPeopleOutline,
	IconUsersDuotone,
	IconUsersOutline,
	IconUsersParticipantsDuotone,
	IconVideoDuotone,
	IconWalkupsDuotone,
	IconZoomInOutline,
	IconZoomOutOutline,
} from '@brandlive/pixel'

const unknownV3Icons = {
	[ICONS.ALIGN_CENTER]: IconFireDuotone,
	[ICONS.ALIGN_LEFT]:  IconFireDuotone,
	[ICONS.ALIGN_RIGHT]:  IconFireDuotone,
	[ICONS.ANIMATION_DISSOLVE]:  IconFireDuotone,
	[ICONS.ANIMATION_MOVE_OUT]:  IconFireDuotone,
	[ICONS.ARROW_DOWN]:  IconFireDuotone,
	[ICONS.BELL]:  IconFireDuotone,
	[ICONS.FILM_CAMERA]:  IconFireDuotone,
	[ICONS.LEAVE]: IconFireDuotone,
	[ICONS.LINK2]: IconFireDuotone,
	[ICONS.MEDIA_DUPLICATE]: IconCopy,
	[ICONS.MONITOR_CANVAS]: IconFireDuotone,
	[ICONS.MONITOR_PRESENTER]: IconFireDuotone,
	[ICONS.MOVE]: IconFireDuotone,
	[ICONS.SEND_INVITE]: IconFireDuotone,
	[ICONS.SETTINGS_SLIDERS]: IconFireDuotone,
	[ICONS.SHARE_SCREEN]: IconShareScreenDuotone,
	[ICONS.SHOT_AUTOPLAY_AUTO]: IconFireDuotone,
	[ICONS.SHOT_AUTOPLAY_MANUAL]: IconFireDuotone,
	[ICONS.SPARKLE]:  IconFireDuotone,
	[ICONS.SQUARE]: IconFireDuotone,
	[ICONS.STREAM_SCHEDULE]: IconFireDuotone,
	[ICONS.TELLY_NOTIFICATION]: IconFireDuotone,
	[ICONS.DOWNLOAD_SPEED]: IconFireDuotone,
	[ICONS.QUALITY]: IconFireDuotone,
	[ICONS.SKIP_ARROWS]: IconFireDuotone,
	[ICONS.STREAM]: IconFireDuotone,
	[ICONS.REFRESH_CIRCLE]: IconFireDuotone,
}

const duotoneIcons = {
	[ICONS.ADD_EVENT]: IconCalendarAddDuotone,
	[ICONS.ADD_INVITE]: IconUserAddDuotone,
	[ICONS.ADD_MEDIA]: IconAddFolderDuotone,
	[ICONS.ARROW_UP]: IconArrowUpDuotone,
	[ICONS.AUDIO_MUTED]: IconSoundOffDuotone,
	[ICONS.BACKGROUND_REMOVE]: IconBackgroundRemoveDuotone,
	[ICONS.BACKGROUND_RESTORE]: IconBackgroundRestoreDuotone,
	[ICONS.BACKWARD]: IconMoveToBottomDuotone,
	[ICONS.BRIEFCASE]: IconCaseProfileDuotone,
	[ICONS.CAMERA_OFF]: IconCameraOffDuotone,
	[ICONS.CAMERA_ON]: IconCameraOnDuotone,
	[ICONS.CHAT_NOTIFICATION]: IconChatDefaultDuotone,
	[ICONS.CHECK_FILLED]: IconCheckboxCheckedDuotone,
	[ICONS.CLOCK]: IconClockDefaultDuotone,
	[ICONS.COMPUTER]: IconDeviceDesktopMonitorDuotone,
	[ICONS.COUNTDOWN]: IconCountdownsOutline,
	[ICONS.DESIGN]: IconTemplateDuotone,
	[ICONS.DISSOLVE]: IconSidenavOnDuotone,
	[ICONS.EDIT]: IconEditDuotone,
	[ICONS.EMAIL_FILLED]: IconEmailDuotone,
	[ICONS.EMOJI]: IconEmojiDuotone,
	[ICONS.ERROR]: IconAlertDuotoneCircle,
	[ICONS.EVENT_NOTIFICATION]: IconCalendarStarMenuMeetingsFavoriteDuotone,
	[ICONS.FAST_FORWARD]: IconFastForwardDuotone,
	[ICONS.FILTER]: IconFilterDuotone,
	[ICONS.FILTER_BOOKENDS]: IconBookendsDuotone,
	[ICONS.FILTER_COUNTDOWNS]: IconCountdownsDuotone,
	[ICONS.FILTER_LOWERS]: IconLowersDuotone,
	[ICONS.FILTER_SEGMENTS]: IconSegmentsDuotone,
	[ICONS.FILTER_STYLEPACKS]: IconStylepacksDuotoneCopy,
	[ICONS.FILTER_WALKUPS]: IconWalkupsDuotone,
	[ICONS.FOLDER]: IconFolderDuotone,
	[ICONS.FONT]: IconFontDuotone,
	[ICONS.HEADPHONES]: IconHeadphonesDuotone,
	[ICONS.IMAGE]: IconImageMediaDuotone,
	[ICONS.INFO_OUTLINE]: IconInfoCircle,
	[ICONS.INFO_CIRCLE]: IconInfoCircle,
	[ICONS.INTERNET_SPEED]: IconMarkerDuotone, // Network/connection speed
	[ICONS.INVITE]: IconUserAddDuotone,
	[ICONS.LOCATION]: IconPinLocationDuotone,
	[ICONS.MEDIA]: IconImageMediaDuotone,
	[ICONS.MEDIA_CONVERT]: IconLayersThreeDuotone, // Media conversion
	[ICONS.MEDIA_EDIT]: IconEditDuotone,
	[ICONS.MEDIA_FILE]: IconFolderDuotone,
	[ICONS.MEDIA_SHARE]: IconArrowShareDuotone,
	[ICONS.MEDIA_TRIM]: IconTrimDuotone,
	[ICONS.MESSAGE]: IconChatDuotone,
	[ICONS.MICROPHONE_OFF]: IconMicOffDuotone,
	[ICONS.MICROPHONE_ON]: IconMicOnDuotone,
	[ICONS.MONITOR]: IconDeviceDesktopMonitorDuotone,
	[ICONS.MUSIC]: IconMusicSoundAudioDuotone,
	[ICONS.MUSIC_NOTE]: IconMusicSoundAudioDuotone,
	[ICONS.MUSIC_NOTE_NEW]: IconMusicSoundAudioDuotone,
	[ICONS.MUTE_SOUND]: IconSoundOffDuotone,
	[ICONS.NOTE]: IconNotesDuotone,
	[ICONS.PEOPLE]: IconUsersParticipantsDuotone,
	[ICONS.PERSON]: IconUserDuotone,
	[ICONS.PERSON_IN_SHOT]: IconShotFrameDuotone,
	[ICONS.PHONE]: IconDeviceMobileDuotone,
	[ICONS.PHOTO]: IconPhotoDuotone,
	[ICONS.PRESENTERS]: IconUsersDuotone,
	[ICONS.SCREENSHARE]: IconShareScreenDuotone,
	[ICONS.SEGMENT]: IconSegmentsDuotone,
	[ICONS.SEND]: IconSendDuotone,
	[ICONS.SETTINGS]: IconSettingsDuotone,
	[ICONS.SHARE]: IconUserAddDuotone,
	[ICONS.SOUND]: IconSoundVolumeUpDuotone,
	[ICONS.STOP_SCREENSHARE]: IconSharescreenOffDuotone,
	[ICONS.TAB_CHAT]: IconChatDuotone,
	[ICONS.TAB_FEEDS]: IconFeedDuotone,
	[ICONS.TAB_MEDIA]: IconImageMediaDuotone,
	[ICONS.TAB_NOTES]: IconNotesDuotone,
	[ICONS.TAKES]: IconStylepacksDuotoneCopy,
	[ICONS.TECH_CHECK_NOTIFICATION]: IconSettingsDuotone,
	[ICONS.TELEPROMPTER]: IconTeleprompterDuotone,
	[ICONS.TEMPLATE_ADD]: IconAddFileCreateNoteScriptDocumentDuotone,
	[ICONS.TEMPLATES]: IconFileDocumentPageScriptTextEmptyDuotone,
	[ICONS.TITLES_OFF]: IconBelowTheFoldDuotone,
	[ICONS.TRANSITION]: IconBookendsDuotone,
	[ICONS.UNLINK]: IconLinkDuotone,
	[ICONS.VIDEO]: IconVideoDuotone,
	[ICONS.VOLUME_0]: IconMuteDuotone,
	[ICONS.VOLUME_1]: IconSoundVolumeDownDuotone,
	[ICONS.VOLUME_MUTE]: IconMuteDuotone,
	[ICONS.WALKUPS]: IconWalkupsDuotone,
	[ICONS.LOWER_THIRDS]: IconLowersDuotone,
	[ICONS.CALENDAR]: IconCalendarDuotone,
	[ICONS.FORWARD]: IconMoveToTopDuotone,
}

const solidIcons = {
	[ICONS.ACCORDION_DOWN]: IconArrowDownSolid,
	[ICONS.ACCORDION_UP]: IconArrowUpSolid,
	[ICONS.ARROW_BUTTON_LEFT]: IconArrowLeft2Solid,
	[ICONS.ARROW_BUTTON_RIGHT]: IconArrowRight2Solid,
	[ICONS.COPY_FILLED]: IconCopyDuplicateSolid,
	[ICONS.DRAG]: IconDragSolid,
	[ICONS.EYE_HIDDEN]: IconHideEye,
	[ICONS.EYE_SHOWN]: IconShowEye,
	[ICONS.FIT]: IconCollapseDuotone,
	[ICONS.FULLSCREEN]: IconExpandDuotone,
	[ICONS.LIVE]: IconLiveSolid,
	[ICONS.LOOP_TRACK_OFF]: IconRepeatOffSolid,
	[ICONS.PAUSE]: IconLayoutFlipHorizontalSolid,
	[ICONS.PLAY]: IconPlaySolid,
	[ICONS.PLAY_PADDING]: IconPlaySolid,
	[ICONS.PLAY_RESET]: IconPreviousArrowSolid,
	[ICONS.PREVIEW]: IconExpandSolid,
	[ICONS.PRIVATE]: IconHandRaiseSolid,
	[ICONS.RECORD]: IconRecordSolid,
	[ICONS.RECORDING]: IconRecordSolid,
	[ICONS.SEND_FILLED]: IconSendSolid,
	[ICONS.STOP_LIVE]: IconNotliveSolid,
	[ICONS.STREAM_PLAY]: IconPlaySolid,
	[ICONS.STREAM_RECORD]: IconRecordSolid,
	[ICONS.STREAM_STOP]: IconStopSolid,
	[ICONS.TITLES]: IconBelowTheFoldSolid,
	[ICONS.TITLES_ON]: IconBelowTheFoldSolid,
	[ICONS.VIRTUAL_BACKGROUND]: IconBackgroundRestoreSolid,
	[ICONS.VOLUME_2]: IconSoundVolumeUpSolid,
	[ICONS.VOLUME_3]: IconSoundVolumeUp2Solid,
}

const outlineIcons = {
	[ICONS.ADD]: IconPlusOutline,
	[ICONS.ANIMATION_IN]: IconLogInOutline,
	[ICONS.ANIMATION_OUT]: IconLogOutOutline,
	[ICONS.ANIMATION_TIMER]: IconTimerOutline,
	[ICONS.ARROW_LEFT]: IconArrowLeftOutline,
	[ICONS.ARROW_LEFT_CURVED]: IconArrowLeftOutline,
	[ICONS.ARROW_RIGHT]: IconArrowRightOutline,
	[ICONS.ARROW_UP_FULL]: IconArrowUpOutline,
	[ICONS.ATTACHMENT]: IconAttachOutline,
	[ICONS.BOLD]: IconBoldOutline,
	[ICONS.CARROT_DOWN]: IconArrowDownOutline,
	[ICONS.CARROT_UP]: IconArrowUpOutline,
	[ICONS.CHECK]: IconCheckOutline,
	[ICONS.CHECK_CIRCLE]: IconRoundCheckOutline,
	[ICONS.CHECK_UNFILLED]: IconCheckboxOutline,
	[ICONS.CHECK_V2]: IconCheckOutline,
	[ICONS.CLOCK_ALT]: IconClockDefaultOutline,
	[ICONS.CLOSE]: IconCloseOutline,
	[ICONS.CLOSE_WIDE]: IconCloseOutline,
	[ICONS.CONNECTION]: IconRocketDuotone,
	[ICONS.DOWNLOAD_ICON]: IconDownloadOutline,
	[ICONS.EMAIL]: IconEmailOutline,
	[ICONS.EXPAND]: IconExternalLinkOutline,
	[ICONS.EYEDROPPER]: IconEyedropperDuotone,
	[ICONS.INFO]: IconInfoOutline,
	[ICONS.ITALIC]: IconItalicOutline,
	[ICONS.KEYBOARD_ARROW_DOWN]: IconArrowDownOutline,
	[ICONS.KEYBOARD_ARROW_LEFT]: IconArrowLeft2Outline,
	[ICONS.KEYBOARD_ARROW_RIGHT]: IconArrowRight2Outline,
	[ICONS.KEYBOARD_ARROW_UP]: IconArrowUpOutline,
	[ICONS.LINK]: IconLinkOutline,
	[ICONS.LIST]: IconListBoxOutline,
	[ICONS.LOG_OUT]: IconLogOutOutline,
	[ICONS.LOOP_TRACK_ON]: IconRepeatOutline,
	[ICONS.MAXIMIZE]: IconAngleDuotone,
	[ICONS.MEDIA_DOWNLOAD]: IconDownloadCloudDefault,
	[ICONS.MEDIA_UNFILLED]: IconImageMediaOutline,
	[ICONS.OL]: IconLayoutNumericListOutline,
	[ICONS.PERSON_BLUR]: IconUserShowPeopleOutline,
	[ICONS.PERSON_UNFILLED]: IconUserOutline,
	[ICONS.PRESENTERS_UNFILLED]: IconUsersOutline,
	[ICONS.QUESTION]: IconQuestionOutline,
	[ICONS.QUESTION_CIRCLE]: IconRoundQuestionOutline,
	[ICONS.RADIO_ON]: IconRadioCheckedOutline,
	[ICONS.REDO]: IconRedoReplaceOutline,
	[ICONS.REFRESH]: IconRefreshOutline,
	[ICONS.REFRESH_TRANSPARENT]: IconRefreshOutline,
	[ICONS.REHEARSAL_NOTIFICATION]: IconReloadOutline,
	[ICONS.SHOWBOARD_ELLIPSES]: IconMenuVertical2Outline,
	[ICONS.SPARKLE_AI]: IconSparkleAiOutline,
	[ICONS.TEXT_UNDERLINE]: IconSaxTextUnderlineOutline,
	[ICONS.THREE_DOTS_HORIZONTAL]: IconMenuHorizontal2ThreeMoreOutline,
	[ICONS.THREE_DOTS_VERTICAL]: IconMenuVertical2Outline,
	[ICONS.THREE_LINES_TRIANGLE]: IconMenuVerticalOutline,
	[ICONS.TIMER]: IconTimerOutline,
	[ICONS.UL]: IconListBoxOutline,
	[ICONS.UNDERLINE]: IconSaxTextUnderlineOutline,
	[ICONS.UNDO]: IconUndoOutline,
	[ICONS.UPLOAD]: IconUploadOutline,
	[ICONS.ZOOM_IN]: IconZoomInOutline,
	[ICONS.ZOOM_OUT]: IconZoomOutOutline,
	[ICONS.SEARCH]: IconSearchOutline,
}

// Map v2 icon names to their v3 component equivalents
// Icons marked as undefined don't have clear v3 equivalents yet
export const V2_TO_V3_ICON_MAP: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>> | undefined> = {
	...unknownV3Icons,
	...duotoneIcons,
	...solidIcons,
	...outlineIcons,
	[ICONS.COPY]: IconCopyDuplicate,
	[ICONS.ADD_CLOSE_CIRCLE]: IconRoundAdd,
	[ICONS.CHECK_PROCESSING]: IconRoundCheck,
	[ICONS.LOCK]: IconLock,
	[ICONS.MEDIA_DELETE]: IconDelete,
	[ICONS.TRASH]: IconDelete,
	[ICONS.VIEWERS_EYE]: IconShowEye,
	[ICONS.CUSTOM_THEME]: IconFireDuotone
};
